/**
 * File created by suenlue on 14.02.21.
 * Copyright (c) 2021 by netTrek GmbH & Co. KG
 */
import { AbstractControl } from '@angular/forms';

function isInvalid ( regExp: RegExp, value: string ): boolean {
  let invalid = true;
  if ( value ) {
    // regExp.test funktionierte hier nicht wegen sehr seltsamer Nebeneffekte
    // eslint-disable-next-line
    // https://teams.microsoft.com/l/message/19:197c0c8015894927a867ced914040828@thread.skype/1613634639311?tenantId=ef46d6e6-0077-4145-920e-f68f2ed3d98c&groupId=8fd779d2-518c-4c9d-8cb9-1cbb1249b433&parentMessageId=1613634639311&teamName=netTrek&channelName=DEV&createdTime=1613634639311
    const matches = value.match ( regExp );
    invalid       = !(matches && matches.length > 0);
  }
  return invalid;
}

// eslint-disable-next-line
const mailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function mailValidatorFct ( control: AbstractControl ): { [ key: string ]: any } | null {
  let invalidMailAddress = isInvalid ( mailRegExp, control.value );
  if ( control.value === '' || control.value === null ) {
    invalidMailAddress = false;
  } // this statement is required for NOT validating the empty input
  // empty input would be explicitly handled by Validators.required
  return invalidMailAddress ? { invalidMailAddress: { value: control.value } } : null;
}

// eslint-disable-next-line
const phoneRegExp = /[\d\+\s\(\)\-]/g;
export function phoneValidatorFct ( control: AbstractControl ): { [ key: string ]: any } | null {
  let invalidPhoneNo = isInvalid ( phoneRegExp, control.value ) ||
    control.value.replace ( /\D/g, '' ).length < 4;
  if ( control.value === '' || control.value === null ) {
    invalidPhoneNo = false;
  }
  return invalidPhoneNo ? { invalidPhoneNo: { value: control.value } } : null;
}

// 1Capital, 1Small, 1Num, 1Special, 8 Characters
const strongPwdRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*-._])[a-zA-Z0-9!@#$%^&*-._]{8,}$/g;
export function strongPwdValidatorFct ( control: AbstractControl ): { [ key: string ]: any } | null {
  return isInvalid ( strongPwdRegExp, control.value ) ? { invalidPassword: { value: control.value } } : null;
}

// eslint-disable-next-line
const zipRegExp = /^[0-9]{4,5}$/g;

export function zipValidatorFct ( control: AbstractControl ): { [ key: string ]: any } | null {
  let value = control.value;
  if ( control.value && typeof control.value === 'number' ) {
    value = control.value.toString ( 10 );
  }
  let invalidZip = isInvalid ( zipRegExp, value );
  if ( control.value === '' || control.value === null ) {
    invalidZip = false;
  }
  return invalidZip ? { invalidZip: { value: control.value } } : null;
}

// eslint-disable-next-line
const clientIdRegExp = /^(D)[0-9]{5}$/gi;

export function clientIdValidatorFct ( control: AbstractControl ): { [ key: string ]: any } | null {
  const invalidClientId = isInvalid ( clientIdRegExp, control.value );
  return invalidClientId ? { invalidClientId: { value: control.value } } : null;
}

// eslint-disable-next-line
const dateRegExp = /\b[0-9]{1,2}[.][0-9]{1,2}[.][0-9]{4}\b/g;

export function dateValidatorFct ( control: AbstractControl ): { [ key: string ]: any } | null {
  const invalidDate = isInvalid ( dateRegExp, control.value );
  return invalidDate ? { invalidDate: { value: control.value } } : null;
}

//
// export function forbiddenNameValidator(nameRe: RegExp): ValidatorFn {
//   return (control: AbstractControl): {[key: string]: any} | null => {
//     const forbidden = nameRe.test(control.value);
//     return forbidden ? {forbiddenName: {value: control.value}} : null;
//   };
// }
